// src/utils/voiceAlert.js
export const playVoiceAlert = (text) => {
  if (!('speechSynthesis' in window)) return;

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'uz-UZ'; // Uzbekistan
  
  // Find a suitable voice if possible
  const voices = window.speechSynthesis.getVoices();
  const uzVoice = voices.find(v => v.lang.includes('uz') || v.lang.includes('tr')); // Turkish is often a fallback for Turkic languages if UZ is missing
  if (uzVoice) utterance.voice = uzVoice;

  utterance.rate = 0.9;
  utterance.pitch = 1.0;
  
  window.speechSynthesis.speak(utterance);
};
